module.exports = __webpack_public_path__ + "static/media/ic_carWhite.e47ceec3.svg";